export const RootGetters = {
  GET_SIDEBAR: 'getSidebar',
  GET_ONLINE: 'getOnline',
  GET_OFFLINE: 'getOffline',
  IS_SMALL_SCREEN: 'isSmallScreen',
  GET_URL: 'getURL'
};

export const RootMutations = {
  SET_SIDEBAR: 'setSidebar',
  SET_ONLINE: 'setOnline',
  SET_SCREEN_WIDTH: 'setScreenWidth',
  SET_URL: 'setURL'
};
